// extracted by mini-css-extract-plugin
export default {"container":"Jq-z","heading":"Kq-z","text":"Lq-z","info":"Mq-z","link":"Nq-z","fullMaxWidth":"Oq-z"};